'use strict';

(function () {
  var PREFIX = 'xw_';
  var TTL_DAYS = 90;
  var COOKIE_DOMAIN = '.xweather.com';
  var CONSENT_COOKIE = 'xw_consent_groups';
  var CONSENT_ANALYTICS = 'xw_consent_analytics';
  var CONSENT_MARKETING = 'xw_consent_marketing';

  var PROD_HOSTS = [
    'xweather.com',
    'www.xweather.com',
    'signup.xweather.com',
    'account.xweather.com',
    'docs.xweather.com',
    'live.xweather.com',
    'demos.xweather.com',
    'new.xweather.com',
  ];
  var PROD_GTM_SNIPPET =
    "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=eHVZDgAF289mENFBIR6uWQ&gtm_preview=env-1&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NVG4QP2');";
  var DEV_GTM_SNIPPET =
    "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=0fmo-IknqpFZfmEnTKx2UA&gtm_preview=env-10&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NVG4QP2');";
  // GTM routing is independent of the existing OneTrust domain-script selection.
  var PROD_GTM_HOSTS = PROD_HOSTS.concat(['data.portal.xweather.com']);
  var isProdHost = PROD_GTM_HOSTS.indexOf(window.location.hostname || '') !== -1;
  var GTM_SNIPPET = isProdHost ? PROD_GTM_SNIPPET : DEV_GTM_SNIPPET;
  var BOOTSTRAP_FAILURE_EVENT = 'signup_analytics_bootstrap_failed';
  var OBSERVABILITY_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,255}$/;
  var CHECKOUT_CORRELATION_STORAGE_KEY = 'xweather:checkout-correlation-id';

  var UTM_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'utm_id', 'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic',
  ];
  var CLICK_ID_KEYS = [
    'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'dclid', 'msclkid', 'li_fat_id', 'fbclid',
    'ttclid', 'twclid', 'rdt_cid', 'epik', 'ScCid', 'yclid', 'sacid',
  ];
  var CAMPAIGN_KEYS = UTM_KEYS.concat(CLICK_ID_KEYS);
  // Every field written per touch; a new touch replaces the whole set so fields never mix across visits.
  var TOUCH_KEYS = CAMPAIGN_KEYS.concat(['landing_page', 'referrer']);
  var GA_CLIENT_ID_KEY = 'ga_client_id';
  // Ad platforms' own cookies, snapshotted (not touch-scoped) for later conversion APIs.
  var AD_COOKIE_KEYS = { fbc: '_fbc', fbp: '_fbp', gcl_aw: '_gcl_aw', gcl_gb: '_gcl_gb', uet_msclkid: '_uetmsclkid' };
  // Written by bundles before the last-non-direct touch model; never treated as real attribution.
  var LEGACY_FALLBACK_VALUES = ['(direct)', '(none)', '(not set)', '(not provided)'];
  var MAX_ATTRIBUTION_LENGTH = 512;

  function setCookie(name, value) {
    if (value === undefined || value === null) return;
    var expires = new Date(Date.now() + TTL_DAYS * 864e5).toUTCString();
    var cookie =
      name +
      '=' +
      encodeURIComponent(String(value)) +
      '; expires=' +
      expires +
      '; path=/' +
      '; domain=' +
      COOKIE_DOMAIN +
      '; SameSite=Lax; Secure';
    document.cookie = cookie;
  }

  function findRawCookie(name) {
    if (!document.cookie) return null;
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(name + '=') === 0) {
        return parts[i].split('=').slice(1).join('=') || '';
      }
    }
    return null;
  }

  function safeDecode(raw) {
    try {
      return decodeURIComponent(raw);
    } catch (_) {
      return null;
    }
  }

  function getCookie(name) {
    var raw = findRawCookie(name);
    if (raw === null) return null;
    var decoded = safeDecode(raw);
    if (decoded === null) {
      reportBootstrapFailure('cookie', new Error('cookie_decode_failed'));
      return null;
    }
    return decoded;
  }

  function getQueryParam(param) {
    var regex = new RegExp('[?&]' + param + '=([^&#]*)');
    var match = regex.exec(window.location.search);
    if (!match) return null;
    var decoded = safeDecode(match[1].replace(/\+/g, ' '));
    if (decoded === null) {
      reportBootstrapFailure('attribution', new Error('query_decode_failed'));
      return null;
    }
    return decoded;
  }

  function runBootstrapStep(stage, fn) {
    try {
      fn();
    } catch (err) {
      reportBootstrapFailure(stage, err);
    }
  }

  function reportBootstrapFailure(stage, err) {
    var correlationId = readObservabilityId(
      ['correlation_id', 'correlationId', 'qa_debug_id', 'qaDebugId', 'debugId'],
      ['xw_correlation_id', 'xw_qa_debug_id'],
      true
    );
    var qaDebugId =
      readObservabilityId(['qa_debug_id', 'qaDebugId', 'debugId'], ['xw_qa_debug_id'], false) ||
      correlationId;
    var payload = compactObject({
      event: BOOTSTRAP_FAILURE_EVENT,
      event_version: 2,
      event_class: 'form_health',
      source: 'browser',
      component: 'xweather_ecommerce_analytics',
      load_outcome: 'failure',
      failure_stage: 'analytics_bootstrap',
      bootstrap_stage: safeEnumValue(stage) || 'unknown',
      error_name: safeEnumValue(err && err.name) || 'Error',
      host_origin: safeOrigin(),
      correlation_id: correlationId,
      qa_debug_id: qaDebugId,
    });

    try {
      var debug = (window.xw_debug = window.xw_debug || {});
      debug.analytics_bootstrap_failures = debug.analytics_bootstrap_failures || [];
      debug.analytics_bootstrap_failures.push(payload);
    } catch (_) { }

    try {
      var dl = (window.dataLayer = window.dataLayer || []);
      dl.push(payload);
    } catch (_) { }
  }

  function readObservabilityId(queryKeys, cookieKeys, includeSessionStorage) {
    for (var i = 0; i < queryKeys.length; i++) {
      var queryValue = readRawQueryValue(queryKeys[i]);
      var safeQueryValue = safeObservabilityId(queryValue);
      if (safeQueryValue) return safeQueryValue;
    }

    if (includeSessionStorage) {
      try {
        var stored = window.sessionStorage && window.sessionStorage.getItem(CHECKOUT_CORRELATION_STORAGE_KEY);
        var safeStored = safeObservabilityId(stored);
        if (safeStored) return safeStored;
      } catch (_) { }
    }

    for (var c = 0; c < cookieKeys.length; c++) {
      var rawCookie = findRawCookie(cookieKeys[c]);
      var decodedCookie = rawCookie === null ? null : safeDecode(rawCookie);
      var safeCookieValue = safeObservabilityId(decodedCookie);
      if (safeCookieValue) return safeCookieValue;
    }

    return null;
  }

  function readRawQueryValue(param) {
    var regex = new RegExp('[?&]' + param + '=([^&#]*)');
    var match = regex.exec(window.location.search);
    if (!match) return null;
    return safeDecode(match[1].replace(/\+/g, ' '));
  }

  function safeObservabilityId(value) {
    if (typeof value !== 'string') return null;
    var trimmed = value.trim();
    return OBSERVABILITY_ID_PATTERN.test(trimmed) ? trimmed : null;
  }

  function safeEnumValue(value) {
    if (typeof value !== 'string') return null;
    var trimmed = value.trim();
    return /^[A-Za-z0-9_.:-]{1,128}$/.test(trimmed) ? trimmed : null;
  }

  function safeOrigin() {
    try {
      if (window.location.origin) return window.location.origin;
      if (window.location.hostname) return 'https://' + window.location.hostname;
    } catch (_) { }
    return null;
  }

  function compactObject(value) {
    var result = {};
    for (var key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        var entry = value[key];
        if (entry !== undefined && entry !== null && entry !== '') {
          result[key] = entry;
        }
      }
    }
    return result;
  }

  function isMeaningfulValue(value) {
    if (value === undefined || value === null) return false;
    if (typeof value === 'string') {
      var trimmed = value.trim();
      if (!trimmed) return false;
      var normalized = trimmed.toLowerCase();
      return normalized !== 'undefined' && normalized !== 'null' && LEGACY_FALLBACK_VALUES.indexOf(normalized) === -1;
    }
    return true;
  }

  function deleteCookie(name) {
    document.cookie =
      name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + COOKIE_DOMAIN + '; SameSite=Lax; Secure';
  }

  function sanitizeAttributionValue(value) {
    if (!isMeaningfulValue(value)) return null;
    var trimmed = String(value).trim();
    if (trimmed.length > MAX_ATTRIBUTION_LENGTH || /[\r\n]/.test(trimmed)) return null;
    return trimmed;
  }

  // Origin + path only: query strings and fragments can carry emails or tokens.
  function originAndPath(url) {
    var match = /^(https?:\/\/[^/?#]+)([^?#]*)/i.exec(url || '');
    if (!match) return null;
    return sanitizeAttributionValue(match[1].toLowerCase() + (match[2] || '/'));
  }

  function isExternalReferrer(url) {
    var match = /^https?:\/\/([^/?#:]+)/i.exec(url || '');
    if (!match) return false;
    var host = match[1].toLowerCase();
    return host !== 'xweather.com' && !/\.xweather\.com$/.test(host);
  }

  // Only a visit carrying a campaign signal is a touch; direct and internal visits change nothing.
  function captureTouch() {
    var touch = {};
    var hasCampaign = false;
    for (var i = 0; i < CAMPAIGN_KEYS.length; i++) {
      var value = sanitizeAttributionValue(getQueryParam(CAMPAIGN_KEYS[i]));
      if (value) {
        touch[CAMPAIGN_KEYS[i]] = value;
        hasCampaign = true;
      }
    }
    if (!hasCampaign) return null;
    touch.landing_page = originAndPath(window.location.href);
    var referrer = document.referrer || '';
    touch.referrer = isExternalReferrer(referrer) ? originAndPath(referrer) : null;
    return touch;
  }

  function hasFirstTouch() {
    for (var i = 0; i < CAMPAIGN_KEYS.length; i++) {
      if (isMeaningfulValue(getCookie(PREFIX + 'ft_' + CAMPAIGN_KEYS[i]))) return true;
    }
    return false;
  }

  function writeTouchSet(prefix, touch) {
    for (var i = 0; i < TOUCH_KEYS.length; i++) {
      var key = TOUCH_KEYS[i];
      if (touch[key]) setCookie(prefix + key, touch[key]);
      else deleteCookie(prefix + key);
    }
  }

  // Held in memory until marketing consent (C0004) is resolved; never stored before that.
  var pendingAttribution = null;

  function flushAttribution() {
    if (!pendingAttribution) return;
    var pending = pendingAttribution;
    pendingAttribution = null;
    if (pending.touch) {
      var writeFirstTouch = !hasFirstTouch();
      writeTouchSet(PREFIX, pending.touch);
      if (writeFirstTouch) writeTouchSet(PREFIX + 'ft_', pending.touch);
    }
    if (pending.gaClientId) setCookie(PREFIX + GA_CLIENT_ID_KEY, pending.gaClientId);
    for (var key in pending.adCookies) setCookie(PREFIX + key, pending.adCookies[key]);
  }

  function captureAdCookies() {
    var found = null;
    for (var key in AD_COOKIE_KEYS) {
      var value = sanitizeAttributionValue(getCookie(AD_COOKIE_KEYS[key]));
      if (value) (found = found || {})[key] = value;
    }
    return found;
  }

  function clearAttribution() {
    pendingAttribution = null;
    var keys = TOUCH_KEYS.concat([GA_CLIENT_ID_KEY, 'ga4_client_id'], Object.keys(AD_COOKIE_KEYS));
    for (var i = 0; i < keys.length; i++) {
      if (findRawCookie(PREFIX + keys[i]) !== null) deleteCookie(PREFIX + keys[i]);
      if (findRawCookie(PREFIX + 'ft_' + keys[i]) !== null) deleteCookie(PREFIX + 'ft_' + keys[i]);
    }
  }

  runBootstrapStep('attribution', function () {
    var touch = captureTouch();
    var gaClientId = sanitizeAttributionValue(extractGaClientId());
    var adCookies = captureAdCookies();
    if (touch || gaClientId || adCookies) pendingAttribution = { touch: touch, gaClientId: gaClientId, adCookies: adCookies || {} };
  });

  function extractGaClientId() {
    var ga = getCookie('_ga');
    if (!ga) return null;
    var parts = ga.split('.');
    if (parts.length >= 4) {
      return parts[2] + '.' + parts[3];
    }
    return ga;
  }

  function normalizeGroups(raw) {
    if (!raw && raw !== 0) return '';
    var str = String(raw).trim();
    if (!str) return '';
    return str.replace(/\s+/g, '');
  }

  function getGroupsFromOneTrust() {
    try {
      if (window.OneTrust && typeof window.OneTrust.GetActiveGroups === 'function') {
        return normalizeGroups(window.OneTrust.GetActiveGroups());
      }
    } catch (_) { }

    try {
      if (window.OneTrustActiveGroups) {
        return normalizeGroups(window.OneTrustActiveGroups);
      }
    } catch (_) { }

    return '';
  }

  var consentState = {};

  function emitConsentEvent(name, granted, groups) {
    if (consentState[name] === granted) return;
    consentState[name] = granted;
    try {
      window.dispatchEvent(
        new CustomEvent(name, {
          detail: {
            granted: granted,
            groups: groups,
          },
        })
      );
    } catch (err) {
      console.warn('Consent event dispatch failed:', err);
    }
  }

  function resolveConsentGroups(explicitGroups) {
    var sources = [
      explicitGroups,
      getGroupsFromOneTrust(),
      extractGroupsFromOptanonCookie(),
      getCookie(CONSENT_COOKIE),
    ];

    for (var i = 0; i < sources.length; i++) {
      var normalized = normalizeGroups(sources[i]);
      if (normalized) return normalized;
    }

    return '';
  }

  function isConsentGroupGranted(groups, category) {
    var entries = groups.split(',');
    var usesSavedStates = groups.indexOf(':') !== -1;
    var granted = false;
    for (var i = 0; i < entries.length; i++) {
      var parts = entries[i].split(':');
      if (parts[0] !== category) continue;
      // Saved states require an explicit 1; conflicting entries fail closed.
      if (usesSavedStates && (parts.length !== 2 || parts[1] !== '1')) return false;
      granted = true;
    }
    return granted;
  }

  function syncConsentCookies(explicitGroups) {
    var groups = resolveConsentGroups(explicitGroups);
    if (!groups) return;

    setCookie(CONSENT_COOKIE, groups);
    setCookie(CONSENT_ANALYTICS, isConsentGroupGranted(groups, 'C0002') ? 'granted' : 'denied');
    setCookie(CONSENT_MARKETING, isConsentGroupGranted(groups, 'C0004') ? 'granted' : 'denied');

    if (isConsentGroupGranted(groups, 'C0004')) flushAttribution();
    else clearAttribution();

    emitConsentEvent('xw-analytics-consent', isConsentGroupGranted(groups, 'C0002'), groups);
    emitConsentEvent('xw-marketing-consent', isConsentGroupGranted(groups, 'C0004'), groups);
  }

  function extractGroupsFromOptanonCookie() {
    var optanon = getCookie('OptanonConsent');
    if (!optanon) return '';

    var match = optanon.match(/groups=([^&]+)/);
    if (!match || match.length < 2) return '';

    try {
      return decodeURIComponent(match[1]).split(',').map(function (entry) {
        return entry.indexOf(':') === -1 ? entry + ':0' : entry;
      }).join(',');
    } catch (_) {
      return '';
    }
  }

  function getOneTrustScriptId() {
    var host = window.location.hostname || '';
    var isProdOneTrustHost = PROD_HOSTS.indexOf(host) !== -1;
    return isProdOneTrustHost
      ? 'c4819a33-b4cd-4509-89f1-14b1e9fe1aff'
      : 'c4819a33-b4cd-4509-89f1-14b1e9fe1aff-test';
  }

  function loadOneTrust() {
    if (window.__xwOneTrustLoaded) return;
    window.__xwOneTrustLoaded = true;

    var script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.setAttribute('data-domain-script', getOneTrustScriptId());
    document.head.appendChild(script);

    window.OptanonWrapper = window.OptanonWrapper || function () { };
  }

  function watchDataLayerForConsent() {
    if (window.__xwConsentDataLayerWatch) return;
    window.__xwConsentDataLayerWatch = true;

    var dl = (window.dataLayer = window.dataLayer || []);

    function processEntry(entry) {
      if (!entry) return;
      var payload =
        entry.OnetrustActiveGroups ||
        entry.OneTrustActiveGroups ||
        entry.OptanonActiveGroups ||
        entry.OptanonActiveConsentGroups;
      if (payload) {
        runBootstrapStep('data_layer', function () {
          syncConsentCookies(payload);
        });
      }
    }

    for (var i = 0; i < dl.length; i++) {
      processEntry(dl[i]);
    }

    var originalPush = dl.push;
    dl.push = function () {
      var args = Array.prototype.slice.call(arguments);
      for (var j = 0; j < args.length; j++) {
        processEntry(args[j]);
      }
      try {
        return originalPush.apply(dl, args);
      } catch (err) {
        reportBootstrapFailure('data_layer', err);
        return dl.length;
      }
    };
  }

  function loadGtm() {
    if (window.__xwGtmLoaded) return;
    window.__xwGtmLoaded = true;

    var tag = document.createElement('script');
    tag.innerHTML = GTM_SNIPPET;
    document.head.appendChild(tag);
  }

  runBootstrapStep('data_layer', watchDataLayerForConsent);
  runBootstrapStep('onetrust', loadOneTrust);
  runBootstrapStep('consent', syncConsentCookies);
  runBootstrapStep('gtm', loadGtm);
})();
